import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import '../../CSS/PreBookModal.css';

  const PreBookModal = ({ product, onClose }) => {
const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    startDate: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    phone: '',
    email: '',
    startDate: ''
  });

  const location = useLocation();
  const currentUrl = window.location.href;

  const validateField = (name, value) => {
    let error = '';

    switch (name) {
      case 'name':
        if (!value.trim()) error = 'Name is required';
        else if (value.trim().length < 2) error = 'Name must be at least 2 characters';
        break;
      case 'phone':
        if (!value) error = 'Phone is required';
        else if (!/^[0-9]{10}$/.test(value)) error = 'Phone must be exactly 10 digits';
        break;
      case 'email':
        if (!value) error = 'Email is required';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) error = 'Invalid email format';
        break;
      case 'startDate':
        if (!value) error = 'Start date is required';
        else if (new Date(value) < new Date().setHours(0,0,0,0)) error = 'Start date cannot be in the past';
        break;
      default:
        error = '';
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (name !== 'message') {
      const error = validateField(name, value);
      setErrors(prev => ({
        ...prev,
        [name]: error
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Check if any errors exist (excluding optional message)
    const hasErrors = Object.values(errors).some(error => error !== '');
    if (hasErrors) {
      alert('Please fix the errors below before submitting');
      return;
    }
    
    if (!formData.name || !formData.phone || !formData.email || !formData.startDate) {
      alert('Please fill all required fields');
      return;
    }

    const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
    const message = `🗓️ Pre-Book Request\n\n` +
      `Product: ${product.title}\n` +
      `Product ID: ${product.product_id}\n` +
      `Name: ${formData.name}\n` +
      `Phone: +91${formData.phone}\n` +
      `Email: ${formData.email}\n` +
      `Preferred Start Date: ${new Date(formData.startDate).toLocaleDateString('en-GB')}\n` +
      `Message: ${formData.message}\n\n` +
      `Current Page URL: ${currentUrl}\n\n` +
      `Available From: ${product.availableFrom}`;

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    onClose();
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <motion.div
      className="modal-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={onClose}
    >
      <motion.div
        className="prebook-modal"
        initial={{ y: -50, scale: 0.9 }}
        animate={{ y: 0, scale: 1 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Pre-Book {product.title}</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fa fa-times" />
          </button>
        </div>
        
        <div className="prebook-product-info">
          <p><strong>Available From:</strong> {new Date(product.availableFrom).toLocaleDateString('en-GB')}</p>
        </div>

        <form onSubmit={handleSubmit} className="prebook-form">
          <div className="pre-form-group">
            <label>Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'error-input' : ''}
              required
            />
            {errors.name && <div className="error-alert">{errors.name}</div>}
          </div>

          <div className="pre-form-group">
            <label>Phone *</label>
            <input
              type="tel"
              name="phone"
              placeholder="xxxxxxxxxx"
              value={formData.phone}
              onChange={handleChange}
              maxLength="10"
              className={errors.phone ? 'error-input' : ''}
              required
            />
            {errors.phone && <div className="error-alert">{errors.phone}</div>}
          </div>

          <div className="pre-form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error-input' : ''}
              placeholder="Enter your email"
              required
            />
            {errors.email && <div className="error-alert">{errors.email}</div>}
          </div>

          <div className="pre-form-group">
            <label>Preferred Start Date *</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              className={errors.startDate ? 'error-input' : ''}
              min={today}
              required
            />
            {errors.startDate && <div className="error-alert">{errors.startDate}</div>}
          </div>

          <div className="pre-form-group">
            <label>Message (Optional)</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              placeholder="Any special requirements?"
            />
          </div>

          <button type="submit" className="prebook-submit-btn">
            Send WhatsApp Message
          </button>
        </form>
      </motion.div>
    </motion.div>
  );
};

export default PreBookModal;